import {
    useEffect,
    useState
} from 'react';

export default function useOnElementDimensionChange(ignoreResizes, changeHandler) {
    const [element, setElement] = useState(null);

    useEffect(() => {
        const handleResize = () => {

            window.requestAnimationFrame(() => {
                changeHandler(element);
            });
        };

        handleResize(element);

        window.addEventListener('load', handleResize);
        if (!ignoreResizes) {
            window.addEventListener('resize', handleResize);
        }

        return () => {
            window.removeEventListener('load', handleResize);
            if (!ignoreResizes) {
                window.removeEventListener('resize', handleResize);
            }
        };
    });

    return {
        ref: setElement
    };
}
